import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { StorageService } from '../services/storage.service';

export const INTRO_KEY = 'intro-seen';

@Injectable({
  providedIn: 'root',
})
export class IntroGuard {
  constructor(private navController: NavController, private storageService: StorageService) {}

  async canLoad(): Promise<boolean> {
    const hasSeenIntro = await this.storageService.getLocalData(INTRO_KEY);
    if (hasSeenIntro && hasSeenIntro === true) {
      return true;
    }
      this.navController.navigateRoot('/intro');

      return false;

  }
}
